// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.riga-testa {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  align-items: baseline;
  margin: 6px 0;
}
.riga-testa > b {
  font-size: 17px;
  font-weight: 800;
  letter-spacing: 0.01em;
  color: var(--ion-text-color);
}

.riga-ruolo {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef2ff;
  color: #1e3a8a;
}

.riga-desc {
  font-size: 13px;
  opacity: 0.85;
}

.riga-altra {
  opacity: 0.7;
}

.freccia-riga, .fine-riga, .separatore-altre {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-medium);
  margin: 6px 0;
}

.freccia-riga {
  color: var(--ion-color-primary);
}

.separatore-altre {
  border-top: 1px solid var(--ion-color-medium);
  padding-top: 8px;
}

.fila {
  display: flex;
  align-items: center;
  overflow-x: auto;
  padding: 6px 4px 8px;
}

.gruppo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: none;
}

.freccia {
  color: var(--ion-color-medium);
  font-size: 20px;
  font-weight: 700;
  flex: none;
  width: 34px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/_components/contenitori/contenitore-percorso/_percorso-riga.scss","webpack://./src/app/_components/contenitori/contenitore-percorso-orizzontale/contenitore-percorso-orizzontale.component.scss","webpack://./src/app/_components/contenitori/contenitore-percorso/_percorso-posizioni.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;ACDJ;ADII;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;ACFN;;ADME;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;ACHJ;;ADME;EACE,eAAA;EACA,aAAA;ACHJ;;ADME;EACE,YAAA;ACHJ;;ADME;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,aAAA;ACHJ;;ADME;EACE,+BAAA;ACHJ;;ADME;EACE,6CAAA;EACA,gBAAA;ACHJ;;AA3CA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AA8CF;;AA3CA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,UAAA;AA8CF;;AA3CA;ECiBE,8BAAA;EACA,eAAA;EACA,gBAAA;EDjBA,UAAA;EACA,WAAA;EACA,kBAAA;AAgDF","sourcesContent":["// Feature 166: intestazione di riga e separatori comuni alle viste del percorso.\n@mixin riga {\n  .riga-testa {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 10px;\n    align-items: baseline;\n    margin: 6px 0;\n\n    // Codice articolo della riga: il dato che l'operatore cerca per primo.\n    > b {\n      font-size: 17px;\n      font-weight: 800;\n      letter-spacing: .01em;\n      color: var(--ion-text-color);\n    }\n  }\n\n  .riga-ruolo {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: .04em;\n    text-transform: uppercase;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: #eef2ff;\n    color: #1e3a8a;\n  }\n\n  .riga-desc {\n    font-size: 13px;\n    opacity: .85;\n  }\n\n  .riga-altra {\n    opacity: .7;\n  }\n\n  .freccia-riga, .fine-riga, .separatore-altre {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-medium);\n    margin: 6px 0;\n  }\n\n  .freccia-riga {\n    color: var(--ion-color-primary);\n  }\n\n  .separatore-altre {\n    border-top: 1px solid var(--ion-color-medium);\n    padding-top: 8px;\n  }\n}\n","@use '../contenitore-percorso/percorso-riga' as r;\n@use '../contenitore-percorso/percorso-posizioni' as p;\n\n@include r.riga;\n\n.fila {\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n  padding: 6px 4px 8px;\n}\n\n.gruppo {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: none;\n}\n\n.freccia {\n  @include p.freccia;\n  flex: none;\n  width: 34px;\n  text-align: center;\n}\n","// Feature 166: colori di posizione condivisi dalle viste del percorso (contrasto >= 4.5:1, mockup).\n@mixin posizioni {\n  .da-fare {\n    background: #ffffff;\n    border: 2px solid #d1d5db;\n    color: #374151;\n  }\n\n  .passata {\n    background: #e8f5ec;\n    border: 2px solid #2e7d4f;\n    color: #1b4d32;\n  }\n\n  .attuale {\n    background: #1d5fd6;\n    border: 2px solid #0f3d91;\n    color: #ffffff;\n    box-shadow: 0 0 0 4px rgba(29, 95, 214, .25);\n  }\n\n  .prossima {\n    background: #fff4e5;\n    border: 2px dashed #c2410c;\n    color: #7c2d12;\n  }\n\n  .alternativa, .fuori {\n    background: #f3f4f6;\n    border: 2px dotted #9ca3af;\n    color: #4b5563;\n  }\n}\n\n// Fuori dalle card: colori del tema, leggibili anche in modalità scura.\n@mixin freccia {\n  color: var(--ion-color-medium);\n  font-size: 20px;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
